<template>
  <div v-if="modalIsOpened" class="fixed inset-0 w-full bg-black/30 z-50">
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
    >
      <div class="w-[100vw] max-w-[1000px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden">
          <div
            id="title"
            class="flex items-center justify-between py-[12px] pl-[20px] pr-[10px] bg-[#9B237B]"
          >
            <span class="PC_Body2-R text-[#FCFCFC]">ตั้งค่าประเภท</span>
            <CloseIcon
              @click="closeModal"
              class="w-[24px] h-[24px] bg-white text-[#9B237B] rounded-full cursor-pointer"
            />
          </div>
          <div class="flex flex-col p-[20px] pt-[12px] gap-[10px] bg-[#FFF]">
            <div class="flex items-center gap-[10px]">
              <div class="w-full">
                <SearchBox
                  :placeholder="'ค้นหา ชื่อประเภท'"
                  v-model="filter.search"
                  @update:modelValue="
                    () => {
                      (filter.page = ''), debouncedFetch();
                    }
                  "
                />
              </div>
              <ButtonComponent
                :icon="'AddIcon'"
                :label="'เพิ่มประเภท'"
                :bClass="'btn_shadow--1 min-w-[114px] h-[42px] !gap-[4px] !px-[10px]'"
                :lClass="'!text-[13px]'"
                @clicked="add"
              />
            </div>
            <!-- table -->
            <div class="min-h-[616px]">
              <table>
                <thead>
                  <tr>
                    <th
                      class="w-full py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left rounded-tl-[6px] border-r-[1px] border-solid border-[#FFFFFF]"
                    >
                      <span class="PC_Body2-R"> ชื่อประเภท </span>
                    </th>
                    <th
                      class="min-w-[102px] py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] rounded-tr-[6px] border-l-[1px] border-solid border-[#FFFFFF]"
                    ></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(row, rowIndex) in productTypeList"
                    :key="rowIndex"
                    :class="[
                      '!border-none',
                      { 'bg-[#FBEFF8]': (rowIndex + 1) % 2 === 0 },
                    ]"
                  >
                    <td class="p-[10px] !border-none max-w-[0px] truncate">
                      <span class="PC_Body2-R text-[#1F1D1F]">
                        {{ row.name }}
                      </span>
                    </td>
                    <td
                      class="min-w-[102px] w-[0%] flex items-center justify-center gap-[10px] p-[10px] !border-none"
                    >
                      <ButtonComponent
                        :icon="'EditIcon'"
                        :bClass="'btn_shadow--2'"
                        :iClass="'w-[24px] h-[24px] p-[2px]'"
                        @clicked="() => edit(row)"
                      />
                      <ButtonComponent
                        :icon="'TrashcanIcon'"
                        :bClass="'btn_shadow--2'"
                        @clicked="() => alertDelete(row)"
                      />
                    </td>
                  </tr>
                  <NoInfoYetComponent
                    class="h-[560px]"
                    v-if="productTypeList.length <= 0"
                    :col="'10'"
                    :icon="'ResourcesIcon'"
                  />
                </tbody>
              </table>
            </div>
            <!-- table -->
            <!-- pagination for modal -->
            <PaginationComponent
              :perPageId="'perpagemodal'"
              :items="pagination"
              @selectedPage="handlePage"
            />
            <!-- pagination for modal -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useProductStore } from "@/pinia/product";
import { storeToRefs } from "pinia";
import { debounce } from "lodash";

const productStore = useProductStore();
const { productTypeList } = storeToRefs(productStore);

const filter = ref({
  paginate: 10,
  page: "",
  search: "",
});
const pagination = ref(null);

const modalIsOpened = ref(false);
const emit = defineEmits(["open", "status", "delete"]);

const openModal = () => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";

  getData();
};

const updateModal = () => {
  filter.value.page = "";
  getData();
};

const closeModal = () => {
  filter.value.search = "";

  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const getData = async () => {
  await productStore
    .getProductType(filter.value)
    .then((response) => {
      if (response.status == 200) {
        pagination.value = response.data.data;
      }
    })
    .catch((error) => {
      if (error) {
        console.log("error", error);
      }
    });
};

const debouncedFetch = debounce(getData, 300);

const add = () => {
  emit("open");
};

const edit = (data) => {
  emit("open", data);
};

const alertDelete = async (data) => {
  if (data.used) {
    emit("delete", data);
  } else {
    const message =
      "หากทำการลบข้อมูลแล้ว \n จะไม่สามารถเรียกคืนข้อมูลดังกล่าวได้ \n ต้องการลบข้อมูลนี้หรือไม่";
    emit("status", message, "warning", "ลบ", data, "type");
  }
};

const handlePage = (page, perpage) => {
  filter.value.page = page;
  filter.value.paginate = perpage;
  getData();
};

defineExpose({ openModal, updateModal, closeModal });
</script>

<style lang="scss" scoped>
</style>